export const FORM_WARNINGS_EVENT = 'formWarnings'
export const FORM_ERRORS_EVENT = 'formErrors'
export const OPEN_STEP_DETAILS_EVENT = 'openStepDetails'
export const ONBOARDING_FLOW_DURATION_EVENT = 'onboardingFlowDuration'
export const SELECT_ALL_STEPS_EVENT = 'selectAllSteps'
export const EXIT_BATCH_EDIT_MODE_EVENT = 'exitBatchEditMode'
export const DESELECT_ALL_STEPS_EVENT = 'deselectAllSteps'
